import { Injectable } from '@angular/core';
import { LocalDbService } from '../local-db-service';
import { Warehouse } from '../../entities/warehouse';
import { SortUtil } from '../../utils/sort.util';

@Injectable({ providedIn: 'root' })
export class WarehouseRepository {
  private get table() {
    return this.db.warehouseTable;
  }

  constructor(private readonly db: LocalDbService) {}

  async getAll(): Promise<Warehouse[]> {
    const rows = await this.table.toArray();
    return SortUtil.sortByStringProperty(rows.map(row => new Warehouse(row)), 'name');
  }

  async getById(id: number): Promise<Warehouse | undefined> {
    const row = await this.table.get(id);
    return row ? new Warehouse(row) : undefined;
  }

  async getByUserManagerId(id: number, regionId: number): Promise<Warehouse | undefined> {
    const row = await this.table.filter(row => row.warehouseManagerId === id && row.regionId === regionId).first();
    return row ? new Warehouse(row) : undefined;
  }

  async getByRegionId(regionId: number): Promise<Warehouse[]> {
    const rows = await this.table.where('regionId').equals(regionId).toArray();
    return SortUtil.sortByStringProperty(rows.map(row => new Warehouse(row)), 'name');
  }

  upsert(warehouse: Warehouse): Promise<number> {
    return this.table.put(warehouse);
  }

  upsertBulk(warehouses: Warehouse[]): Promise<number> {
    return this.table.bulkPut(warehouses);
  }

  delete(id: number): Promise<void> {
    return this.table.delete(id);
  }

  clear(): Promise<void> {
    return this.table.clear();
  }

}
